import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { FRIEND_REQUEST_ID_STORAGE_KEY } from '@/utils/constants';

interface FriendRequestCountState {
  friendRequestIds: number[];
}

interface FriendRequestCountActions {
  updateFriendRequestId(id: number[]): void;

  clearAllFriendRequestId(): void;
}

type FriendRequestCountStore = FriendRequestCountState & FriendRequestCountActions;

export const useFriendRequestCountStore = create<FriendRequestCountStore>()(
  persist(
    immer((set) => ({
      friendRequestIds: [],

      updateFriendRequestId(ids) {
        set((state) => {
          state.friendRequestIds = ids;
        });
      },

      clearAllFriendRequestId() {
        set((state) => {
          state.friendRequestIds = [];
        });
      },
    })),
    {
      name: FRIEND_REQUEST_ID_STORAGE_KEY,
      version: 3,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        friendRequestIds: state.friendRequestIds,
      }),
      migrate: () => ({
        friendRequestIds: [],
      }),
    },
  ),
);
